/**
 *  v2 テンプレート専用
 *  tab-contents の切り替え (bootstrap.jsの置き換え)
 **/
$(function() {
  'use strict';

  $(document).on('click','[data-toggle="tab"]',function(e) {
    e.preventDefault();
    var $this = $(this);

    if ( $this.hasClass('active')) return;
    if ( $this.hasClass('disabled')) return;
    var selector = $this.attr('href')
    //console.log(selector);

    var $target = $(selector);
    var $old = $target.parent().find('> .active');
    console.log($old);
    if ( $old ) {
      $old.removeClass('active');
    }
    //$target.show();
    $target.addClass('active');

    var $old_tab = $this.parent().find('> .disabled');
    if ( $old_tab ) {
      $old_tab.removeClass('disabled');
    }
    $this.addClass('disabled');



  });



});

